import React from 'react';
import {useSignalBuilderStore} from './SignalBuilder.state';
import {Box, Flex, GridItem} from '@chakra-ui/react';
import {LabelInput} from './helpers';
import Select from 'react-select';
import {useFieldDefinition} from '../../../hooks/api/metadata';
import {AccountFieldOrCustomField} from '../../../shared/signalDefinition';
import {isAccountField} from '../../../shared/fields/keyplay';
import {Category} from '../../../shared/fields/enrichment';

export const CategorySignalBuilder = ({
  field,
  isDisabled = false,
}: {
  field: AccountFieldOrCustomField;
  isDisabled?: boolean;
}) => {
  const {evalFn, setEvalFn, setLabel} = useSignalBuilderStore();

  if (isAccountField(field)) {
    throw new Error('Cannot create signals for account fields');
  }

  const fieldDefinition = useFieldDefinition(field);
  if (!fieldDefinition) {
    throw new Error('Field definition not found');
  }

  if (
    fieldDefinition.type !== 'ai' ||
    fieldDefinition.config.fieldType !== 'category'
  ) {
    throw new Error('Field config fieldType must be category');
  }

  if (evalFn && evalFn.type !== 'equal' && evalFn.type !== 'in') {
    throw new Error('Invalid evalFn type');
  }

  const categories = fieldDefinition.config.categories || [];
  const categoryOptions = categories.map((category: Category) => ({
    value: category.name,
    label: category.name,
  }));

  const maxCategories = fieldDefinition.config.maxCategories ?? 1;
  const evalType = maxCategories >= 2 ? 'in' : 'equal';

  const update = (categoryName: string) => {
    setEvalFn({
      type: evalType,
      field,
      value: categoryName,
    });
    setLabel(categoryName);
  };

  return (
    <>
      <GridItem as={Flex} alignItems="center" flexDirection="row" gap="4">
        <Box w="100%">
          <Select
            isDisabled={isDisabled}
            isMulti={false}
            options={categoryOptions}
            value={categoryOptions.find(
              (option) => option.value === evalFn?.value
            )}
            onChange={(newValue) => {
              if (!newValue) {
                return;
              }

              update(newValue.value);
            }}
            placeholder="Select a category"
          />
        </Box>
      </GridItem>
      <GridItem alignSelf="center">
        <LabelInput />
      </GridItem>
    </>
  );
};
